import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

const rand = (a, b) => Math.random() * (b - a) + a;
const COLORS = ['bg-[hsl(var(--kche-yellow))]', 'bg-[hsl(var(--kche-cyan))]', 'bg-[hsl(var(--kche-pink))]', 'bg-[hsl(var(--kche-green))]'];

export const Particles = ({ count = 14, className }) => {
    const [dots, setDots] = useState([]);
    useEffect(() => {
        const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReduced) return;
        const arr = Array.from({ length: count }).map((_, i) => ({
            id: i,
            top: `${rand(5, 90)}%`,
            left: `${rand(2, 96)}%`,
            size: rand(6, 12),
            color: COLORS[i % COLORS.length],
            delay: `${rand(0, 4).toFixed(2)}s`,
        }));
        setDots(arr);
    }, [count]);
    return (
        <div className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)} aria-hidden="true">
            {dots.map((d) => (
                <span
                    key={d.id}
                    className={cn('absolute rounded-full opacity-70 animate-confetti', d.color)}
                    style={{ top: d.top, left: d.left, width: d.size, height: d.size, animationDelay: d.delay }}
                />
            ))}
        </div>
    );
};

export const Blobs = ({ className }) => (
    <div className={cn('pointer-events-none absolute inset-0 overflow-hidden', className)} aria-hidden="true">
        <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-[hsl(var(--kche-cyan))]/20 blur-3xl animate-blob" />
        <div className="absolute top-1/3 -right-20 w-96 h-96 rounded-full bg-[hsl(var(--kche-pink))]/20 blur-3xl animate-blob" style={{ animationDelay: '3s' }} />
        <div className="absolute -bottom-24 left-1/3 w-80 h-80 rounded-full bg-[hsl(var(--kche-yellow))]/15 blur-3xl animate-blob" style={{ animationDelay: '6s' }} />
    </div>
);

export default Particles;
